import React, { useCallback, useRef, useState } from "react";
import { connect } from "react-redux";
import "../../../../../om/css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import { LoadPanel } from "devextreme-react/load-panel";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    HeaderFilter,
    SearchPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";

const LotResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "a7d3e1c2-9b4f-4c8a-a1e6-3f2d7b0c8e91";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);

    const onSelectionChanged = ({ selectedRowsData }) => {
        if (props.onLotSelected) {
            props.onLotSelected(selectedRowsData[0]);
        }
    };

    return (
        <div style={{ height: '100%' }} id="lotResultContainer">
            <LoadPanel
                visible={props.loading === true}
                shading={true}
                shadingColor="rgba(0,0,0,0.08)"
                showIndicator={true}
                showPane={true}
                message="Loading..."
                position={{ my: "center", at: "center", of: "#lotResultContainer" }}
            />
            <DataGrid
                onExporting={(e) => {
                    if (window.handleDevExtremeDataGridExport) {
                        window.handleDevExtremeDataGridExport(e);
                    }
                }}
                ref={dataGrid}
                height="100%"
                dataSource={props.data}
                keyExpr="RowId"
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                remoteOperations={true}
                columnAutoWidth={true}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <HeaderFilter visible={true} />
                <SearchPanel visible={true} width={240} placeholder="Search..." />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                {/* Default-visible columns */}
                <Column dataField="CustomerName" caption="Customer Name" />
                <Column dataField="LotCode" caption="Lot" />
                <Column dataField="Description1" caption="Lot Description 1" />
                <Column dataField="Description2" caption="Lot Description 2" />
                <Column dataField="LotClassCode" caption="Class" />
                <Column dataField="LotSubclassCode" caption="Sub Class" />
                <Column dataField="OnHandLot" caption="Lot On Hand" />
                <Column dataField="AvailableLot" caption="Lot Available" />
                <Column dataField="NetAvailableLot" caption="Lot Net Available" />
                <Column dataField="ItemCode" caption="Item" />
                <Column dataField="ItemDescription1" caption="Item Description 1" />
                {/* Column chooser (hidden by default) */}
                <Column dataField="CustomerIdentity" caption="Customer" visible={false} />
                <Column dataField="InReceivingLot" caption="Lot In Receiving" visible={false} />
                <Column dataField="OutShippedLot" caption="Lot In Shipping" visible={false} />
                <Column dataField="OutUnavailableLot" caption="Lot UnAvailable" visible={false} />
                <Column dataField="InOrderedLot" caption="Lot Pending Rec" visible={false} />
                <Column dataField="OutOrderedLot" caption="Lot Pending Ship" visible={false} />
                <Column dataField="LotBOReceiving" caption="Lot BO Receiving" visible={false} />
                <Column dataField="LotBoShipping" caption="Lot BO Shipping" visible={false} />
                <Column dataField="FutureRecLot" caption="Lot Future Rec" visible={false} />
                <Column dataField="FutureShipLot" caption="Lot Future Ship" visible={false} />
                <Column dataField="DateIntroduced" caption="Date Introduced Lot" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="DateExpiredLot" caption="Date Expired Lot" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="DateAvailable" caption="Date Available Lot" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="LotCode1" caption="Lot Code 1" visible={false} />
                <Column dataField="LotCode2" caption="Lot Code 2" visible={false} />
                <Column dataField="LotCode3" caption="Lot Code 3" visible={false} />
                <Column dataField="LotCode4" caption="Lot Code 4" visible={false} />
                <Column dataField="LotCode5" caption="Lot Code 5" visible={false} />
                <Column dataField="LotCode6" caption="Lot Code 6" visible={false} />
                <Column dataField="LotCode7" caption="Lot Code 7" visible={false} />
                <Column dataField="LotCode8" caption="Lot Code 8" visible={false} />
                <Column dataField="LotCode9" caption="Lot Code 9" visible={false} />
                <Column dataField="LotCode10" caption="Lot Code 10" visible={false} />
                <Column dataField="LotReference1" caption="Lot Reference 1" visible={false} />
                <Column dataField="LotReference2" caption="Lot Reference 2" visible={false} />
                <Column dataField="LotReference3" caption="Lot Reference 3" visible={false} />
                <Column dataField="LotReference4" caption="Lot Reference 4" visible={false} />
                <Column dataField="LotReference5" caption="Lot Reference 5" visible={false} />
                <Column dataField="LotReference6" caption="Lot Reference 6" visible={false} />
                <Column dataField="LotReference7" caption="Lot Reference 7" visible={false} />
                <Column dataField="LotReference8" caption="Lot Reference 8" visible={false} />
                <Column dataField="LotReference9" caption="Lot Reference 9" visible={false} />
                <Column dataField="LotReference10" caption="Lot Reference 10" visible={false} />
                <Column dataField="LotDate1" caption="Lot Date 1" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="LotDate2" caption="Lot Date 2" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="LotDate3" caption="Lot Date 3" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="LotDate4" caption="Lot Date 4" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="LotDate5" caption="Lot Date 5" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="LotDate6" caption="Lot Date 6" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="LotDate7" caption="Lot Date 7" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="LotDate8" caption="Lot Date 8" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="LotDate9" caption="Lot Date 9" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="LotDate10" caption="Lot Date 10" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="LotQuantity1" caption="Lot Quantity 1" visible={false} />
                <Column dataField="LotQuantity2" caption="Lot Quantity 2" visible={false} />
                <Column dataField="LotQuantity3" caption="Lot Quantity 3" visible={false} />
                <Column dataField="LotQuantity4" caption="Lot Quantity 4" visible={false} />
                <Column dataField="LotQuantity5" caption="Lot Quantity 5" visible={false} />
                <Column dataField="LotQuantity6" caption="Lot Quantity 6" visible={false} />
                <Column dataField="LotQuantity7" caption="Lot Quantity 7" visible={false} />
                <Column dataField="LotQuantity8" caption="Lot Quantity 8" visible={false} />
                <Column dataField="LotQuantity9" caption="Lot Quantity 9" visible={false} />
                <Column dataField="LotQuantity10" caption="Lot Quantity 10" visible={false} />
                <Column dataField="ItemDescription2" caption="Item Description 2" visible={false} />
                <Column dataField="ItemClassCode" caption="Item Class Code" visible={false} />
                <Column dataField="ItemSubclassCode" caption="Item Subclass Code" visible={false} />
                <Column dataField="OnHandItem" caption="Item On Hand" visible={false} />
                <Column dataField="InReceivingItem" caption="Item In Receiving" visible={false} />
                <Column dataField="OutShippedItem" caption="Item In Shipping" visible={false} />
                <Column dataField="OutUnavailableItem" caption="Item UnAvailable" visible={false} />
                <Column dataField="AvailableItem" caption="Item Available" visible={false} />
                <Column dataField="InOrderedItem" caption="Item Pending Rec" visible={false} />
                <Column dataField="OutOrderedItem" caption="Item Pending Ship" visible={false} />
                <Column dataField="ItemBOReceiving" caption="Item BO Receiving" visible={false} />
                <Column dataField="ItemBoShipping" caption="Item BO Shipping" visible={false} />
                <Column dataField="NetAvailableItem" caption="Item Net Available" visible={false} />
                <Column dataField="FutureRecItem" caption="Item Future Rec" visible={false} />
                <Column dataField="FutureShipItem" caption="Item Future Ship" visible={false} />
                <Column dataField="DateIntroducedItem" caption="Date Introduced Item" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="DateExpiredItem" caption="Date Expired Item" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="DateAvailableItem" caption="Date Available Item" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="ItemCode1" caption="Item Code 1" visible={false} />
                <Column dataField="ItemCode2" caption="Item Code 2" visible={false} />
                <Column dataField="ItemCode3" caption="Item Code 3" visible={false} />
                <Column dataField="ItemCode4" caption="Item Code 4" visible={false} />
                <Column dataField="ItemCode5" caption="Item Code 5" visible={false} />
                <Column dataField="ItemCode6" caption="Item Code 6" visible={false} />
                <Column dataField="ItemCode7" caption="Item Code 7" visible={false} />
                <Column dataField="ItemCode8" caption="Item Code 8" visible={false} />
                <Column dataField="ItemCode9" caption="Item Code 9" visible={false} />
                <Column dataField="ItemCode10" caption="Item Code 10" visible={false} />
                <Column dataField="ItemReference1" caption="Item Reference 1" visible={false} />
                <Column dataField="ItemReference2" caption="Item Reference 2" visible={false} />
                <Column dataField="ItemReference3" caption="Item Reference 3" visible={false} />
                <Column dataField="ItemReference4" caption="Item Reference 4" visible={false} />
                <Column dataField="ItemReference5" caption="Item Reference 5" visible={false} />
                <Column dataField="ItemReference6" caption="Item Reference 6" visible={false} />
                <Column dataField="ItemReference7" caption="Item Reference 7" visible={false} />
                <Column dataField="ItemReference8" caption="Item Reference 8" visible={false} />
                <Column dataField="ItemReference9" caption="Item Reference 9" visible={false} />
                <Column dataField="ItemReference10" caption="Item Reference 10" visible={false} />
                <Column dataField="ItemDate1" caption="Item Date 1" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="ItemDate2" caption="Item Date 2" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="ItemDate3" caption="Item Date 3" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="ItemDate4" caption="Item Date 4" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="ItemDate5" caption="Item Date 5" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="ItemDate6" caption="Item Date 6" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="ItemDate7" caption="Item Date 7" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="ItemDate8" caption="Item Date 8" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="ItemDate9" caption="Item Date 9" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="ItemDate10" caption="Item Date 10" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="ItemQuantity1" caption="Item Quantity 1" visible={false} />
                <Column dataField="ItemQuantity2" caption="Item Quantity 2" visible={false} />
                <Column dataField="ItemQuantity3" caption="Item Quantity 3" visible={false} />
                <Column dataField="ItemQuantity4" caption="Item Quantity 4" visible={false} />
                <Column dataField="ItemQuantity5" caption="Item Quantity 5" visible={false} />
                <Column dataField="ItemQuantity6" caption="Item Quantity 6" visible={false} />
                <Column dataField="ItemQuantity7" caption="Item Quantity 7" visible={false} />
                <Column dataField="ItemQuantity8" caption="Item Quantity 8" visible={false} />
                <Column dataField="ItemQuantity9" caption="Item Quantity 9" visible={false} />
                <Column dataField="ItemQuantity10" caption="Item Quantity 10" visible={false} />
                <Column dataField="Department" caption="Department" visible={false} />
                <Column dataField="JobLot" caption="Job Lot" visible={false} />
                <Column dataField="DeptLot" caption="Dept Lot" visible={false} />
                <Column dataField="CreationDateTime" caption="Creation Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="CreationUserId" caption="Created By" visible={false} />
                <Column dataField="LastUpdateDateTime" caption="Last Updated" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="LastUpdateUserId" caption="Last Updated By" visible={false} />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LotResult);
